import { memo, PropsWithChildren } from "react";

import { useRequiredData } from "effect/use_required_data";

import LoaderModal from "layouts/components/LoaderModal";

// -----------------------------------------------------------------------------

export const LoadRequiredData = memo(function LoadRequiredData({
  children,
}: PropsWithChildren): JSX.Element {
  const ready = useRequiredData();

  //
  return ready ? (children as any) : <LoaderModal />;
});
